// 这个存放和业务相关的工具函数，可以引入vuex，也可以发起请求
import userStore from "@/store/modules/user";
import commonAppStore from "@common/src/store/modules/app";
import store from "@/store";
import uploadImageHandler from "./editor";
import appCode from "@common/src/utils/app-code";
import commonApp from "@common/src/store/modules/app";
import commonBase from "@common/src/store/modules/base";
import _ from "lodash";

export function formDownload(url, param) {
  let kyes = Object.keys(param);
  let paramArr = kyes.map(item => {
    return {
      name: item,
      value: _.isNil(param[item]) ? "" : param[item] // 剔除null  undefined 等无效字段
    };
  });
  paramArr.push({
    name: "userAuthToken",
    value: userStore.state.token
  });
  paramArr.push({
    name: "userLanguage",
    value: store.getters["common_app/severLanguage"]
  });
  console.log(paramArr);
  var form = document.createElement("form");
  document.getElementsByTagName("body")[0].appendChild(form);
  form.setAttribute("style", "display:none");
  form.setAttribute("target", "_blank");
  form.setAttribute("method", "post");
  form.setAttribute("action", url);
  paramArr.forEach(item => {
    var input1 = document.createElement("input");
    input1.setAttribute("type", "hidden");
    input1.setAttribute("name", item.name);
    input1.setAttribute("value", item.value);
    form.appendChild(input1);
  });
  form.submit();
  form.remove();
}

export function editorUploadHandler(options) {
  new uploadImageHandler(options);
}

/**
 *金额添加货币符号
 * @param money 金额
 * @param split 是否千位分割
 * @returns 结果
 */
export function addCurrencySymbol(money, split = false) {
  return moneyFormat(money, split);
}

/**
 *金额添加货币单位 收款金额(元)
 * @param money 金额
 * @param split 是否千位分割
 * @param hasBrackets 货币单位是否有括号
 * @returns 结果
 */
export function addCurrencyUnit(money, split = false, hasBrackets = false) {
  split;
  hasBrackets;
  return money;
}

/**
 * 当前国家是否符合提供的国家集合
 * @param {Array} 国家集合
 * @returns {Boolean} show
 */
export function showOfCountrys(countryArr = []) {
  return countryArr.includes(commonAppStore.state.country);
}

/**
 * @param {Array} 权限控制按钮级别
 * @returns {Boolean} show
 */
export function permit(permisKey) {
  if (_.isString(permisKey)) {
    return userStore.state.permissionList.includes(permisKey);
  } else {
    return permisKey.some(key => {
      return userStore.state.permissionList.includes(key);
    });
  }
}

/**
 * @param {Sting} 权限控制应用级别
 * @returns {Boolean} show
 */
export function permitApp(appName) {
  if (_.isString(appName)) {
    return appName === appCode;
  } else {
    return appName.includes(appCode);
  }
}

/**
 * @param {Sting} 权限控制国家级别
 * @returns {Boolean} show
 */
export function permitCountry(countryName) {
  if (_.isString(countryName)) {
    return countryName === commonApp.state.country;
  } else {
    return countryName.includes(commonApp.state.country);
  }
}

/**
 * 千位分割
 * @param {number | string} num 要处理的值
 * @param separator 分割符号
 * @return {string}
 */
export function splitThousands(num, separator = ",") {
  const toNumber = parseFloat(num);
  if (isNaN(Number(num)) || isNaN(toNumber)) return num;
  const flag = toNumber < 0 ? "-" : "";
  let numStr = String(num);
  const end = numStr.split(".")[1] ? "." + numStr.split(".")[1] : "";
  const arr = [...String(Math.abs(parseInt(num)))];
  let result = "";
  while (arr.length > 3) {
    result = separator + arr.splice(-3).join("") + result;
  }
  return flag + arr.join("") + result + end;
}

/**
 *国际化数字表示
 * @param value 要格式化的值
 * @param split 是否千位分割
 * @param symbol 是否显示货币符号 prefix
 * @param unit 是否显示货币单位 suffix
 * @param unitBrackets 货币单位是否用括号包裹 10.00(元)
 * symbol = false, unit = false, unitBrackets = false
 */
export function moneyFormat(value, split = false, symbol = false, unit = false, unitBrackets = false) {
  if (_.isNil(value)) {
    console.log(`${value} not Number or String Number ${symbol && unit && unitBrackets}`);
    return "";
  }
  const separator = commonBase.state.separator || ",";
  const decimalPlaces = _.isNil(commonBase.state.decimalPlaces) ? 2 : commonBase.state.decimalPlaces;
  const valueNum = Number(value);
  if (appCode === "speedbiz-operation") {
    return split ? splitThousands(valueNum.toFixed(2), ",") : valueNum.toFixed(2);
  }
  return split ? splitThousands(valueNum.toFixed(decimalPlaces), separator) : valueNum.toFixed(decimalPlaces);
}

/**
 * 合并零配件名字和自定义编号
 * @param partsData 零配件对象
 * @return partsComb 自护字符串
 */
export function partsPropComb(partsData) {
  return partsData.partsCustomizeCode
    ? `${partsData.partsNameDesc}(${partsData.partsCustomizeCode})`
    : partsData.partsNameDesc;
}

/**
 * Number.prototype的自定义方法保留小数位-根据国家
 * @return
 */
export function i18nToFixed(): string {
  const decimalPlaces = _.isNil(commonBase.state.decimalPlaces) ? 2 : commonBase.state.decimalPlaces;
  return this.toFixed(decimalPlaces);
}
